"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/expertsSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeFifteenExpertsSectionGeneratedProps = {
    /** Default: "2s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Our Experts" */
    sectionDiv0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Hear From the People Who" */
    sectionDiv0Div0Div0H20H2Text?: ReactNode;
    /** Default: "Have" */
    sectionDiv0Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Experienced" */
    sectionDiv0Div0Div0H20Span0SpanText?: ReactNode;
};

const HomeFifteenExpertsSectionGenerated: FC<HomeFifteenExpertsSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0DivText = "Our Experts",
    sectionDiv0Div0Div0H20H2Text = "Hear From the People Who",
    sectionDiv0Div0Div0H20H2Text2 = "Have",
    sectionDiv0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0H20H2Props,
    sectionDiv0Div0Div0H20Span0SpanText = "Experienced",
    sectionDiv0Div0DivDataWowDuration = "2s",
}) => {
    return (
        <section className="section testimonial-section-fifteen">
            <div className="container">
                <div className="section-header section-header-fifteen text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div>
                        <div className="section-sub-title">{sectionDiv0Div0Div0Div0DivText}</div>
                        {renderNode(sectionDiv0Div0Div0H20H2Visible, sectionDiv0Div0Div0H20H2Renderer, (
                            <h2 className="section-title" {...(sectionDiv0Div0Div0H20H2Props ?? {})}>
                                {sectionDiv0Div0Div0H20H2Text}
                                <br />
                                {sectionDiv0Div0Div0H20H2Text2}
                                <span>{sectionDiv0Div0Div0H20Span0SpanText}</span>
                            </h2>
                        ))}
                    </div>
                </div>
                <div className="testimonial-details-fifteen">
                    {[
                        {
                            img: "user-lg-1.jpg",
                            name: "Rudy Novack",
                            location: "Canada",
                            text: "Therapy helped me manage anxiety and improve emotional wellbeing. practical guidanc carefully, and created a safe space. I now feel confident, balanced, and stronger.",
                        },
                        {
                            img: "user-lg-2.jpg",
                            name: "Emma Richardson",
                            location: "USA",
                            text: "Counseling sessions helped me overcome depression and stress. I gained clarity, coping strategies, and emotional support. Now I feel motivated, hopeful, and mentally stronger.",
                        },
                        {
                            img: "user-lg-3.jpg",
                            name: "Olivia Bennett",
                            location: "Germany",
                            text: "The supportive environment made opening up easier. I learned techniques to manage panic attacks and negative thoughts. I feel calmer, positive, and emotionally stable.",
                        },
                        {
                            img: "user-lg-4.jpg",
                            name: "Rudy Novack",
                            location: "Canada",
                            text: "Therapy helped me manage anxiety and improve emotional wellbeing. The therapist provided practical guidance and created a safe space.",
                        },
                        {
                            img: "user-lg-5.jpg",
                            name: "Sophia Martinez",
                            location: "Spain",
                            text: "Professional and compassionate support helped me overcome emotional challenges. The experience truly changed my life.",
                        },
                        {
                            img: "user-lg-6.jpg",
                            name: "Liam Connor",
                            location: "Canada",
                            text: "The personalized therapy sessions helped me understand my emotions and improve relationships. I now feel more stable and optimistic.",
                        },
                    ].map((item, index) => (
                        <div
                            key={index}
                            className={`testimonial-item-fifteen item-${index + 1}`}
                        >
                            <div className="testimonial-author-img">
                                <SmartImage
                                    src={`/Templates/Doccure/img/users/${item.img}`}
                                    alt={item.name}
                                    className="img-fluid"
                                />
                            </div>

                            <div className="star-rating">
                                {[...Array(5)].map((_, i) => (
                                    <i key={i} className="fas fa-star" />
                                ))}
                            </div>

                            <p className="description">{item.text}</p>

                            <div className="author-name">
                                <div>
                                    <SmartLink href="#" className="name">
                                        {item.name}
                                    </SmartLink>
                                    <p className="location">{item.location}</p>
                                </div>

                                <SmartImage
                                    src="/Templates/Doccure/img/icons/quatation-icon-1.svg"
                                    alt="quotation"
                                    className="img-fluid"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeFifteenExpertsSectionGenerated;
